import { useQueryHelper } from '@anytag/shared-hooks';
import { PostDetailsType } from '@anytag/shared-types';
import { UNEXPECTED_ERROR } from '@anytag/shared-constants';
import { CircularProgress, ModalBody } from '@anytag/shared-atoms';
import { useInstagramUGCManagementPostDetailsQuery } from '@anytag/graphql';
import { usePreviousTemplate } from '../hooks';
import { AnalyticsSelectedAccountInfo } from '../../../../types';
import { StaffTemplate } from './StaffTemplate';
import { DefaultTemplate } from './DefaultTemplate';

export interface UGCPostDetailsProps extends Pick<PostDetailsType, 'id'>, ReturnType<typeof usePreviousTemplate> {
  onCloseModal?: () => void;
  analyticsAccount: AnalyticsSelectedAccountInfo;
}

export const UGCPostDetails = ({
  id,
  onCloseModal,
  analyticsAccount,
  previousTemplate,
  setPreviousTemplate
}: UGCPostDetailsProps) => {
  const { t, enqueueSnackbar } = useQueryHelper();

  const { data, loading } = useInstagramUGCManagementPostDetailsQuery({
    skip: !id || !analyticsAccount.id,
    fetchPolicy: 'cache-and-network',
    variables: { instagramAnalyticsAccountId: analyticsAccount.id, postSNSId: String(id) },
    onCompleted: (data) => {
      setPreviousTemplate(data?.instagramUGCManagementPostDetails?.showStaffRequest ? 'staff' : 'default');
    },
    onError: (error) => {
      enqueueSnackbar(t(error?.message || UNEXPECTED_ERROR), { variant: 'error' });
      onCloseModal?.();
    }
  });

  const postDetails = data?.instagramUGCManagementPostDetails;
  const showStaffRequest = !!postDetails?.showStaffRequest;

  return (
    <ModalBody className="p-0">
      <div className={previousTemplate === 'staff' ? 'min-h-171.75' : 'min-h-80'}>
        {loading ? (
          <div className="flex size-full min-h-[inherit] items-center justify-center">
            <CircularProgress size={64} thickness={1} className="bg-black-30" />
          </div>
        ) : postDetails ? (
          showStaffRequest ? (
            <StaffTemplate data={postDetails} analyticsAccount={analyticsAccount} />
          ) : (
            <DefaultTemplate data={postDetails} analyticsAccount={analyticsAccount} />
          )
        ) : null}
      </div>
    </ModalBody>
  );
};
